import React, {Component} from 'react'
import { withStyles } from '@material-ui/styles';
import {ResponsiveContainer, PieChart, Pie, Cell} from 'recharts'
import { green, blue, amber, grey, purple,  cyan, deepOrange } from '@material-ui/core/colors';

const styles = (theme) => ({
  root:{}
})


const empty_data = [
  { name: 'Sin registro', value: 1 },
]

//const COLORS = [purple[700], indigo[700], blue[700], lightBlue[700], 
//cyan[700], teal[700], green[700], lightGreen[700], lime[700], yellow[700], amber[700], orange[700], deepOrange[700]];

const COLORS = [purple[700], blue[700], cyan[700], 
 green[700],  amber[700],  deepOrange[700]];

const RADIAN = Math.PI / 180;
const renderCustomizedLabel = ({
  cx, cy, midAngle, innerRadius, outerRadius, percent, index,
}) => {
   const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
  const x = cx + radius * Math.cos(-midAngle * RADIAN);
  const y = cy + radius * Math.sin(-midAngle * RADIAN);

  return (
    <text x={x} y={y} fill="white" textAnchor={x > cx ? 'start' : 'end'} dominantBaseline="central">
      {`${(percent * 100).toFixed(0)}%`}
    </text>
  );
};

class InactivePatientStatsChart extends Component {
  render(){
    const {data} = this.props

    let isValid = false
    if(data){
      if(data.length){
        data.forEach(item => {
          if(item.value !== 0){
            isValid = true
          }
        })
      }
    }



    return(
      <div style={{ height:'350px'}}>
        <ResponsiveContainer>
          <PieChart>
            <Pie 
            data={isValid ? data : empty_data} 
            fill="#8884d8" 
            labelLine={false}
            label={renderCustomizedLabel}>
              {
                data.map((entry, index) => <Cell key={index.toString()} fill={isValid ? COLORS[index % COLORS.length] : grey[400]}/>)
              }
            </Pie>
          </PieChart>
        </ResponsiveContainer>
      </div>
    )
  }
}

export default withStyles(styles)(InactivePatientStatsChart)